import Airplane from '../../../assets/icons/airplane-img.svg';

const SeatSelectionStyles = theme => ({
  backgroundWrapper: {
    width: '100%',
    height: '1280px',
    // display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    // overflow: 'auto',
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'block',
    flexWrap: 'wrap',
    background: `url(${Airplane}) center center no-repeat`,
    backgroundSize: '1989px 1280px',
    userSelect: 'none',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
  },
});

export default SeatSelectionStyles;



// WEBPACK FOOTER //
// ./src/containers/seats/mobile/SeatSelectionMobileContainerStyles.js